export default "/images/arrow.svg?d4233b29f2b2696ed02f88c079097a84";